export default "__VITE_ASSET__CYPlusH4__"